/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RestaurantTypeValues {
  Self = 'Self',
  Cafeteria = 'Cafeteria',
  ClickAndCollect = 'ClickAndCollect',
  RoomService = 'RoomService',
  RestaurationRapide = 'RestaurationRapide',
  Brasserie = 'Brasserie',
  DinnerTakeaway = 'DinnerTakeaway',
  Foodles = 'Foodles',
  PrestationSurMesure = 'PrestationSurMesure',
  RestaurantExterne = 'RestaurantExterne',
  Scorp = 'Scorp',
}
